import React, { useEffect, useState } from 'react';
import { ClockIcon, UsersIcon } from 'lucide-react';
const TOTAL_SLOTS = 1000;
const REMAINING = 728;
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
/** Countdown resets to ~1h15m so the timer always shows urgency. */
function useCountdown(initialSeconds: number) {
  const [secs, setSecs] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => {
      setSecs(s => s <= 1 ? initialSeconds : s - 1);
    }, 1000);
    return () => clearInterval(id);
  }, [initialSeconds]);
  return {
    h: Math.floor(secs / 3600),
    m: Math.floor(secs % 3600 / 60),
    s: secs % 60
  };
}
function TimeBox({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-56">
      <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-[var(--pb-navy)] font-display text-3xl font-800 text-[var(--pb-lime)] tabular-nums" data-id="element-57">
        {pad(value)}
      </div>
      <span className="mt-1 text-[10px] font-600 uppercase tracking-wider text-white/50" data-id="element-58">
        {label}
      </span>
    </div>;
}
export function CountdownUrgency() {
  const {
    h,
    m,
    s
  } = useCountdown(75 * 60 + 12);
  const pct = Math.round(REMAINING / TOTAL_SLOTS * 100);
  return <div className="rounded-2xl border border-red-300/40 bg-[#251827]/95 p-4 shadow-lg shadow-black/20" data-id="element-59">
      <div className="flex items-center justify-center gap-2 text-red-200" data-id="element-60">
        <ClockIcon size={16} data-id="element-61" />
        <span className="text-xs font-700 uppercase tracking-widest" data-id="element-62">
          Offer Ends Soon
        </span>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-63">
        <TimeBox value={h} label="Hours" data-id="element-64" />
        <span className="font-display text-3xl font-800 text-white/55" data-id="element-65">:</span>
        <TimeBox value={m} label="Min" data-id="element-66" />
        <span className="font-display text-3xl font-800 text-white/55" data-id="element-67">:</span>
        <TimeBox value={s} label="Sec" data-id="element-68" />
      </div>

      <div className="mt-4" data-id="element-69">
        <div className="mb-1.5 flex items-center justify-between text-xs" data-id="element-70">
          <span className="flex items-center gap-1.5 font-600 text-white/90" data-id="element-71">
            <UsersIcon size={13} className="text-[var(--pb-lime)]" data-id="element-72" />
            Spots Remaining
          </span>
          <span className="font-800 text-[var(--pb-lime)]" data-id="element-73">
            {REMAINING} / {TOTAL_SLOTS}
          </span>
        </div>
        <div className="h-3 w-full overflow-hidden rounded-full bg-white/15" data-id="element-74">
          <div className="h-full rounded-full bg-[var(--pb-lime)]" style={{
          width: `${pct}%`
        }} data-id="element-75" />
        </div>
        <p className="mt-1.5 text-center text-[11px] text-white/75" data-id="element-76">
          Launch-price spots are going fast.
        </p>
      </div>
    </div>;
}